import { surfaceColorShades } from '@/theme/ganzimmunColors'

export const ganzimmunLightScheme = {
  surface: surfaceColorShades,
  primary: {
    color: '{primary.500}',
    contrastColor: '{ganzimmun.black}',
    hoverColor: '{primary.600}',
    activeColor: '{primary.700}'
  },
  highlight: {
    background: '{primary.50}',
    focusBackground: '{primary.100}',
    color: '{ganzimmun.darkBlue}',
    focusColor: '{primary.800}'
  },
  formField: {
    color: '{ganzimmun.black}',
    borderColor: '{surface.300}',
    hoverBorderColor: '{primary.400}',
    focusBorderColor: '{ganzimmun.aquamarine}'
  },
  text: {
    color: '{ganzimmun.black}',
    hoverColor: '{primary.800}',
    mutedColor: '{surface.700}',
    hoverMutedColor: '{surface.800}'
  },
  content: {
    borderColor: '{surface.200}',
    hoverBackground: '{surface.100}'
  }
}
